module.exports = __webpack_public_path__ + "static/media/cover_breakfast.3f919df5.png";